"use strict";
/*!
 * Copyright (C) 2019, NewFoundry, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var lodash_1 = __importDefault(require("lodash"));

var errors_1 = require("./errors");

var Terms = __importStar(require("./Terms"));

var Token_1 = require("./Token");

var Rule_1 = require("./Rule");

var Validator = function () {
  function Validator(opts) {
    if (opts === void 0) {
      opts = {};
    }

    this.data = {};
    this.invalidResponse = {
      condition: 'Rule was formatted incorrectly. The condition failed validation.',
      context: '',
      ids: 'Rule contains SKUs not found in provided data opts',
      structure: ''
    };

    if (!lodash_1["default"].isEmpty(opts)) {
      this.data.attribute = opts.attributes;
      this.data.property = opts.properties;
    }
  }

  Validator.prototype.run = function (rules) {
    if (lodash_1["default"].isString(rules)) {
      return this.validateRule(rules);
    }
  };

  Validator.prototype.validateRule = function (str) {
    var rule = new Rule_1.Rule(str);
    var response = {
      valid: false,
      rule: rule
    };

    try {
      this.validateStructure(rule.tokens, response);
    } catch (e) {
      response.err = e;
      response.msg = this.invalidResponse.structure;
      return response;
    }

    try {
      this.validateCondition(rule.getCondition(), response);
    } catch (e) {
      response.err = e;
      response.msg = this.invalidResponse.condition;
      return response;
    }

    try {
      this.validateContext(rule.tokens, response);
    } catch (e) {
      response.err = e;
      response.msg = this.invalidResponse.context;
      return response;
    }

    try {
      this.validateIds(rule.tokens, response);
    } catch (e) {
      response.err = e;
      response.msg = this.invalidResponse.ids;
      return response;
    }

    response.valid = true;
    return response;
  };

  Validator.prototype.validateSet = function (rules) {
    var _this = this;

    var response = rules.map(function (rule) {
      return _this.validateRule(rule);
    });
    var validRules = response.filter(function (r) {
      return r.valid;
    }).map(function (r) {
      return r.rule;
    });
    var rulesMap = {};
    validRules.map(function (rule) {
      var condition = Token_1.Token.mash(rule.getCondition());
      var result = rule.getResult();

      if (!rulesMap[condition]) {
        rulesMap[condition] = [result];
        return;
      }

      rulesMap[condition].push(result);
    });
    lodash_1["default"].keys(rulesMap).forEach(function (condition) {
      var results = rulesMap[condition];

      _this.validateResults(results);
    });
  };

  Validator.prototype.validateCondition = function (tokens, response) {
    var If = Terms.If,
        Then = Terms.Then,
        Id = Terms.Id,
        And = Terms.And,
        Or = Terms.Or,
        Falsy = Terms.Falsy,
        GroupClose = Terms.GroupClose,
        GroupOpen = Terms.GroupOpen;
    var illegal = tokens.filter(function (t) {
      var legal = [If.token, Then.token, Id.token, And.token, Or.token, GroupOpen.token, GroupClose.token, Falsy.token];
      return !legal.includes(t.token);
    });

    if (illegal.length) {
      throw new errors_1.ValidationError("Illegal keyword(s) '" + illegal.map(function (i) {
        return i.value;
      }).join(', ') + "' used in condition");
    }
  };

  Validator.prototype.validateContext = function (tokens, response) {
    var Id = Terms.Id,
        And = Terms.And,
        Or = Terms.Or,
        GroupClose = Terms.GroupClose,
        GroupOpen = Terms.GroupOpen,
        Falsy = Terms.Falsy,
        Value = Terms.Value,
        GenericAction = Terms.GenericAction;
    tokens.map(function (t, index) {
      switch (t.token) {
        case And.token:
        case Or.token:
          {
            var prev = tokens[index - 1];
            var next = tokens[index + 1];
            var prevValid = [GroupClose.token, Id.token];
            var nextValid = [GroupOpen.token, Id.token, Falsy.token, Value.token, GenericAction.token];

            if (!next) {
              response.errAt = index;
              throw new errors_1.ValidationError("Logical operator '" + t.token + " found at the end of a rule");
            }

            if (!prevValid.includes(prev.token)) {
              response.errAt = index;
              throw new errors_1.ValidationError("Invalid keyword '" + prev.token + "' found grouped with '" + t.token + "'. '" + t.token + "' is usually used to group SKUs or groups of parentheses");
            }

            if (!nextValid.includes(next.token)) {
              response.errAt = index;
              throw new errors_1.ValidationError("Invalid keyword '" + next.token + "' found grouped with '" + t.token + "'. '" + t.token + "' is usually used to group SKUs or groups of parentheses");
            }
          }
      }
    });
  };

  Validator.prototype.validateIds = function (tokens, response) {
    var Id = Terms.Id;

    if (lodash_1["default"].isEmpty(this.data)) {
      return;
    }

    var allIds = [];

    if (this.data.attribute) {
      allIds = allIds.concat(this.data.attribute.allIds);
    }

    if (this.data.property) {
      allIds = allIds.concat(this.data.property.allIds);
    }

    tokens.map(function (token) {
      if (token.token === Id.token) {
        if (!allIds.includes("" + token.value)) {
          response.errAt = token.index;
          throw new errors_1.ValidationError("Rule contains id '" + token.value + "' not contained found in provided opts");
        }
      }
    });
  };

  Validator.prototype.validateOpts = function (opts) {
    lodash_1["default"].values(opts.features.byId).forEach(function (feature) {});
  };

  Validator.prototype.validateResults = function (results) {
    var And = Terms.And,
        Or = Terms.Or;
    var orResults = lodash_1["default"].remove(results, function (tokens) {
      return lodash_1["default"].find(tokens, function (t) {
        return t.token === Or.token;
      });
    });
    results.forEach(function (tokens) {
      var groups = [];
      var last = 0;
      tokens.forEach(function (t, index) {
        if (t.token === And.token) {
          groups.push(lodash_1["default"].slice(tokens, last, index));
          last = index + 1;
        }
      });

      if (last < tokens.length) {
        groups.push(lodash_1["default"].slice(tokens, last));
      }

      groups.forEach(function (tokens) {});
    });
  };

  Validator.prototype.validateStructure = function (tokens, response) {
    var If = Terms.If,
        Then = Terms.Then,
        GroupClose = Terms.GroupClose,
        GroupOpen = Terms.GroupOpen;
    var types = tokens.map(function (t) {
      return t.token;
    });

    if (tokens[0].token !== If.token) {
      response.errAt = 0;
      throw new errors_1.ValidationError("Rules must start with the keyword '" + If.value + "'");
    }

    if (!types.includes(Then.token)) {
      throw new errors_1.ValidationError("Rule is missing the keyword '" + Then.value + "'");
    }

    var opens = tokens.filter(function (t) {
      return t.token === GroupOpen.token;
    });
    var closes = tokens.filter(function (t) {
      return t.token === GroupClose.token;
    });

    if (opens.length > closes.length) {
      response.errAt = opens[0].index;
      throw new errors_1.ValidationError('Opening parenthesis is missing a closing parenthesis');
    }

    if (closes.length > opens.length) {
      response.errAt = closes[closes.length - 1].index;
      throw new errors_1.ValidationError('Rule has extra closing parenthesis');
    }

    var uniqueTerms = tokens.filter(function (t) {
      return t.opts.unique === true;
    });
    uniqueTerms.map(function (unique) {
      var count = tokens.filter(function (t) {
        return t.token === unique.token;
      });

      if (count.length > 1) {
        response.errAt = count[1].index;
        throw new errors_1.ValidationError("There can only be one instance of keyword '" + unique + "' per rule");
      }
    });
  };

  return Validator;
}();

exports["default"] = Validator;